import { labouringEndpoints } from "@omega/omp-api";
import type { RequestConfig } from "@app/config/axios/http";
import { ompTransport } from "@src/api/ompTransport";
import type { PaginationReturns } from "@src/api/types/PaginationReturns";
import type { ApiLabouring, ApiLabouringFilter } from "./types";

/**
 * Транспортный слой OMP — справочник работников.
 * Контракт и wire-формат — из пакета `@omega/omp-api`.
 */
export const labouringApi = {
    /**
     * Загружает работников по фильтру с поддержкой серверной пагинации.
     * Запрос уходит в endpoint `labouring.loadListByFilter`.
     */
    load: async (
        params: {
            flt?: ApiLabouringFilter;
            offset?: number;
            limit?: number;
        },
        config?: RequestConfig,
    ): Promise<PaginationReturns<ApiLabouring>> => {
        const { flt, offset, limit } = params;
        return labouringEndpoints.loadListByFilter.call(
            ompTransport,
            {
                ...flt,
                Pagination: {
                    Offset: offset,
                    Limit: limit,
                },
            },
            config,
        );
    },
} as const;
